const React = require('react');
const TextField = require('@material-ui/core/TextField').default;


module.exports = ({
  label,
  ...props
}) => {
  return (
    <TextField
      margin="none"
      variant="outlined"
      {...props}
      placeholder={props.placeholder || label}
      className={`
        o50>.MuiInputBase-input.Mui-disabled
        (pv19|pt17|hmin56|bxzBB|cF|fw4|ff$2|cr@mouse|crT:f!)>.MuiOutlinedInput-input
        (ph20)>(input|.*Input-multiline)
        (fw4|dn)>(input|textarea):i
        (o0)>.Mui-focused>(input|textarea):i
        (o100:h)>:not[.Mui-focused]>.MuiOutlinedInput-input:i
        pv0>textarea.MuiOutlinedInput-input
        st-4.5>fieldset
        (dn|f15|ov|r8|bgF2:h)>.MuiOutlinedInput-root*2
        bg04>.*OutlinedInput-root.*-focused*3
        b2>.*-notchedOutline*2
        bcF.15(>*|:h>*|>.*-focused):not[.*-error]>.*-notchedOutline*2
        (f15|ff$2|fw5|x20y19s100|cA3A7AC:not[.*-error]!)>.*InputLabel
        cF>[data-shrink=true].*InputLabel:not[.*-error]
        (bgFF7070.05|bcEC4C4C)>.*-error>.*-notchedOutline*2
        TextFieldReg ` + (props.className || '')
      }
    />
  );
};
